export default __webpack_public_path__ + "static/media/sowmz-window.7edd504b.jpg";